import client from './client'
import utilUri from '@/util/uri'

export default {
  get: (identifer = '', params = {}, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(params, token)
      //const uri = identifer ? `admin/services/${identifer}` : `admin/services`
      const uri = identifer ? `services/${identifer}` : `services`
      client.get(uri, options)
        .then((res) => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

